import React, { useContext } from "react";
import { EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiText } from "@elastic/eui";
import _ from "lodash";
import { EntityProfileContext } from ".";

import { singular } from "../../../../../utils/stringUtils";
import * as S from "./style";
import EntityIcon from "../EntityIcon";

const renderValue = (unit, value) => (
    <EuiFlexGroup
        responsive={false}
        gutterSize="xs"
        alignItems="flexEnd"
    >
        <EuiFlexItem grow={false}>
            <EuiText color="ghost">
                <h1 className="stats-value">{_.isNil(value) ? "N/A" : value}</h1>
            </EuiText>
        </EuiFlexItem>

        <EuiFlexItem grow={false}>
            <EuiText
                size="s"
                color="ghost"
            >
                <span>{unit}</span>
            </EuiText>
        </EuiFlexItem>
    </EuiFlexGroup>
);

function ProfileStatsEntity({
    option: { name, title, unit, entityName, color, icon },
    stats = {},
}) {
    const { entityDisplayName: profileEntityName } = useContext(EntityProfileContext);

    const titleString = entityName
        ? `${_.capitalize(singular(profileEntityName))} ${entityName}`
        : title;

    return (
        <S.ProfileStatsEntityWrapper
            color={color}
            direction="column"
        >
            <EuiFlexItem grow={false}>
                <EuiFlexGroup
                    alignItems="center"
                    gutterSize="s"
                    responsive={false}
                >
                    <EuiFlexItem
                        grow={false}
                        className="entityIcon__container"
                    >
                        {icon || <EntityIcon entityName={entityName?.toLowerCase()} />}
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>{titleString}</EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>

            <EuiHorizontalRule margin="s" />

            <EuiFlexItem grow={false}> {renderValue(entityName || unit, stats[name])}</EuiFlexItem>
        </S.ProfileStatsEntityWrapper>
    );
}

export default ProfileStatsEntity;
